import classNames from 'classnames'

type TefsirBodyProps = {
  /** Tefsir HTML from the bundled Diyanet data (`tefsir_html`). */
  html: string
  className?: string
}

/** Renders the Diyanet tefsir text below a `TefsirToggle`. */
const TefsirBody = ({ html, className }: TefsirBodyProps) => (
  <div
    className={classNames(
      'mt-3 text-main text-sm sm:text-base leading-relaxed opacity-90 space-y-3',
      className,
    )}
    // The HTML comes from our own bundled Diyanet tefsir files, not from users.
    dangerouslySetInnerHTML={{ __html: html }}
  />
)

export default TefsirBody
